import {CesiumAdapterService} from "../cesiumAdapter21/cesium-adapter.service";
import {Injectable} from "@angular/core";
import {OverlayCollection} from "./OverlayCollection";

@Injectable({
  providedIn: 'root',
})
export class OverlayCollectionFactory {

  constructor(private view:CesiumAdapterService) {}

  public get() {
    return new OverlayCollection(this.view, this);
  }

}


